import { render, staticRenderFns } from "./novaPropostaVida.vue?vue&type=template&id=ec1887fc&scoped=true"
import script from "./novaPropostaVida.vue?vue&type=script&lang=js"
export * from "./novaPropostaVida.vue?vue&type=script&lang=js"
import style0 from "./novaPropostaVida.vue?vue&type=style&index=0&id=ec1887fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1887fc",
  null
  
)

export default component.exports